/**
 * 工具方法
 */

const utils = {

    // 验证是否是邮箱
    isEmail(str) {
        var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        return reg.test(str);
    }
}

export default utils;